module.exports = __webpack_public_path__ + "img/tripdaze-tablet-and-mobile.c2357088.jpg";